import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";

import { STUDENT_INFO_STUDENT } from "../const/StudentInfoConst";

/**
 * Data Access for the User API
 * @name StudentInfoDao
 * @param {{}} props
 * @return {null|*}
 */
const StudentInfoDao = (props) => {
    const { action, schoolYearKey, studentNumber, token } = props;
    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        },
        withCredentials: true
    };
    switch (action) {
        case "studentImageRead":
            options.method = "GET";
            options.responseType = "blob";
            options.url = `${STUDENT_INFO_STUDENT}/${studentNumber}/${schoolYearKey}/image`;
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

StudentInfoDao.propTypes = {
    action: PropTypes.string.isRequired,
    schoolYearKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    studentNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    token: PropTypes.string.isRequired
};

StudentInfoDao.defaultProps = {
    schoolYearKey: null,
    studentNumber: null
};

export default StudentInfoDao;
